export const authConfig = {
  clientId: process.env.REACT_APP_CLIENT_ID,  
  tenantId: process.env.REACT_APP_TENANT_ID,
  redirectUri: `${window.location.origin}/auth/callback`,
  scopes: [
    "offline_access",
    "openid",
    "profile",
    "email",
    "User.Read"
  ],
  teamsResource: `api://app.csuitesscorecard.online/${process.env.REACT_APP_CLIENT_ID}`,
  getLoginUrl: (isTeams = false) => {
    console.log(process.env.REACT_APP_CLIENT_ID, 'here');
    const params = new URLSearchParams({
      client_id: authConfig.clientId,
      response_type: 'code',
      redirect_uri: authConfig.redirectUri,
      scope: authConfig.scopes.join(' '),
      response_mode: 'query',
      prompt: 'select_account'
    });

    if (isTeams) {
      params.append('resource', authConfig.teamsResource);
    }

    // Use common endpoint for better hybrid environment support
    return `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?${params.toString()}`;
  }
}; 
